<template>
  <div class="matrix-board-item" :class="itemClasses">
    <div class="item-inner">
      <div class="item-content">
        <!-- Header mit Land/Flag -->
        <div v-if="isHeader" class="item-header">
          <p class="country-name">{{ kpi.country }}</p>
          <div class="flag-icon" :class="[`flag-icon-${kpi.id.toLowerCase()}`]">
          </div>
        </div>

        <!-- Quartale -->
        <div class="quarters-container">
          <div  v-for="(quarter, index) in kpi.quarters"
                :key="quarter.id"
                class="quarter-item"
                :class="{
                  'is-highlighted': quarter.isHighlighted }">
            <div class="quarter-label">{{ quarter.label }}</div>

            <div class="quarter-value">
              <span class="value-main">{{ quarter.value }}</span>
              <span class="value-unit"><sub>%</sub></span>
            </div>

            <div class="quarter-progress">
              <div class="progress-bar">
                <div
                  class="progress-fill"
                  :style="{ width: quarter.progress + '%' }"
                  :class="getProgressClass(quarter.progress)"
                ></div>
              </div>
            </div>

            <div class="quarter-change" :class="getChangeClass(quarter.change)">
              <span class="change-sign">{{ quarter.change >= 0 ? '+' : '' }}</span>
              <span class="change-value">{{ Math.abs(quarter.change) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MatrixBoardItem',
  props: {
    kpi: {
      type: Object,
      required: true
    },
    isHeader: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    itemClasses() {
      return {
        'is-header': this.isHeader
      };
    },
  },
  methods: {
    getRegion(localization, isHeader) {
      if (!localization || !localization[0].localizationTextId.includes("-"))
        return "";
      else {
        if (isHeader)
          console.error(localization, ' => ', localization[0].localizationTextId.split("-")[1].toLowerCase());
        return localization[0].localizationTextId.split("-")[1].toLowerCase();
      }
    },
    getProgressClass(progress) {
      if (progress >= 90) return 'progress-high';
      if (progress >= 70) return 'progress-medium';
      return 'progress-low';
    },
    getChangeClass(change) {
      if (change > 0) return 'change-positive';
      if (change < 0) return 'change-negative';
      return 'change-neutral';
    }
  }
};
</script>

<style scoped>
.matrix-board-item {
  /* width: 252.81px; */
  /* transform: skewX(-18.882deg); */
  /* border: 1px solid rgba(255, 255, 255, 0.1); */
  background: transparent;
  min-width: 16rem;
  min-height: 10rem;
}

.item-inner {
  /* transform: skewX(18.882deg); */
  padding: 0.5rem;
}

.item-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.country-name {
  font-size: 0.875em;
  padding-left: 0.25rem;
  font-weight: 700;
  line-height: 16px;
  color: var(--color-foreground);
  margin: 0;
}

.flag-icon {
  width: 20px;
  height: 20px;
}

.quarters-container {
  display: flex;
  justify-content: flex-end;
  gap: 6px;
}

.quarter-item {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--bs-border-color);
  align-items: center;
  gap: 8px;
  padding: 8px 8px;
  min-width: 56px;
}

.quarter-item.is-highlighted {
  background: rgba(0, 201, 80, 0.1);
  border: 1px solid rgba(0, 201, 80, 0.1);
}

.quarter-label {
  font-size: 11px;
  line-height: 11px;
  /* color: rgba(255, 255, 255, 0.4); */
}


.quarter-value {
  display: flex;
  align-items: flex-end;
  gap: 4px;
}

.value-main {
  font-size: 12px;
  line-height: 42px;
}

.quarter-item.is-highlighted .quarter-value {
  gap: 0px;
}
.quarter-item.is-highlighted .value-main {
  font-size: 18px;
}
.quarter-item.is-highlighted .value-unit {
  font-size: 14px;
}
.value-unit {
  font-size: 10px;
  line-height: 42px;
  /* color: rgba(255, 255, 255, 0.4); */
}

.quarter-progress {
  width: 100%;
  min-width: 25px;
}

.progress-bar {
  display: flex;
  align-items: center;
  height: 2px;
  width: 100%;
  background: rgba(255, 255, 255, 0.1);
}

.progress-fill {
  height: 2px;
  transition: width 0.3s ease;
}

.progress-fill.progress-high {
  background: var(--default-status-indifferent);
}

.progress-fill.progress-medium {
  background: var(--default-status-green);
}

.progress-fill.progress-low {
  background: var(--default-status-red);
}

.quarter-change {
  display: flex;
  align-items: center;
  gap: 2px;
  font-size: 12px;
  line-height: 12px;
}

/*
  // Default Status Colors
  --default-status-indifferent:       #{$default-status-indifferent};
  --default-status-red:               #{$default-status-red};
  --default-status-yellow:            #{$default-status-yellow};
  --default-status-green:             #{$default-status-green}; */



.change-positive {
  color: var(--default-status-green);
}

.change-negative {
  color: var(--default-status-red);
}

.change-neutral {
  color: var(--default-status-indifferent);
}
</style>
